import { render, staticRenderFns } from "./reset_pass.vue?vue&type=template&id=7718fb86&scoped=true&"
import script from "./reset_pass.vue?vue&type=script&lang=js&"
export * from "./reset_pass.vue?vue&type=script&lang=js&"
import style0 from "./reset_pass.vue?vue&type=style&index=0&id=7718fb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7718fb86",
  null
  
)

export default component.exports